import React, {useRef, useState} from 'react';
import {useDispatch} from 'react-redux';
import styled from 'styled-components';
import Modal from '../../../../Modal/Modal';
import LoadingIndicator from '../../../../LoadingIndicator/LoadingIndicator';
import {useEngagementId, useDocumentId} from '../../../../../../../src/util/customHooks';
import {currentResource} from '../../../../../../../src/util/utils';
import EllipsesControl from '../../../../EllipsesControl/EllipsesControl';
import {deleteSampleItem} from '../../../../../../actions/SampleItems/sampleItemActions';

const DeleteSample = ({
	showModal,
	onHideModal,
	sampleListId,
	sampleItemId,
	sampleName,
	sampleItemLabels,
	onDeleteSuccess
}) => {
	const labels = currentResource.labels;
	const [isLoading, setIsLoading] = useState(false);
	const [loaderHeight, setLoaderHeight] = useState(0);
	const engagementId = useEngagementId();
	const documentId = useDocumentId();
	const dispatch = useDispatch();
	const ref = useRef(null);

	const loaderProps = {
		height: loaderHeight,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	};
	const getHeightOfSection = () => {
		setLoaderHeight(ref.current.clientHeight);
	};

	const handleDelete = () => {
		setIsLoading(true);
		const queryString = {
			documentId: documentId
		};

		dispatch(deleteSampleItem(engagementId, sampleListId, sampleItemId, queryString))
			.then(() => {
				onDeleteSuccess();
			})
			.finally(() => {
				setIsLoading(false);
				onHideModal();
			});
	};

	return (
		<Modal
			show={showModal}
			modalsize={'x-small'}
			showButtons
			title={sampleItemLabels.deleteSampleHeader}
			closeBtnTitle={labels.cancelButtonLabel}
			confirmBtnTitle={labels.delete}
			onHide={() => onHideModal()}
			closeTitle={labels.cancelButtonLabel}
			isOkButtonDisabled={isLoading}
			isCancelButtonDisabled={isLoading}
			onOkClick={() => {
				getHeightOfSection();
				handleDelete();
			}}
			okTitle={labels.delete}
			disableClose={isLoading}
		>
			<StyledDeleteModal className="StyledDeleteModal">
				{isLoading ? (
					<section style={loaderProps} className="loader-section">
						<LoadingIndicator show view="inlineView" />
					</section>
				) : (
					<section ref={ref}>
						<section className="modal-description">{sampleItemLabels.deleteSmapleDescription}</section>
						<section className="delete-sample-details">
							<span className="desc-ellipse">
								<EllipsesControl content={sampleName} tooltip={sampleName} noOfLines={3} />
							</span>
						</section>
					</section>
				)}
			</StyledDeleteModal>
		</Modal>
	);
};

export default DeleteSample;

const StyledDeleteModal = styled.section`
	.modal-description {
		padding-bottom: var(--px-24);
		font-size: var(--px-16);
		font-weight: 300;
		line-height: var(--px-24);
		color: var(--neutrals-900);
		border-bottom: var(--px-1) solid var(--neutrals-100);
	}
	.delete-sample-details {
		padding-top: var(--px-24);
		font-size: var(--px-14);
		line-height: var(--px-20);
		color: var(--neutrals-900);
		display: flex;
		justify-content: row;
		gap: var(--px-4);
		.pre-text {
			font-weight: 300;
			white-space: nowrap;
		}
		.desc-ellipse {
			flex: 1;
			font-weight: 400;
		}
	}
`;
